import ExternalLink from 'components/generic/ExternalLink.component';
import { useGilt, useTranslation } from 'providers/GILT.provider';

import CN from './CardItem.module.scss';

const CardItem = ({ imageSrc, title, link }) => {
  const { t } = useTranslation();
  const { isSalonInGB } = useGilt();

  return (
    <div data-bem="CardItem" className={CN.component}>
      <div className={CN.imageContainer}>
        <img src={imageSrc} alt={title} />
      </div>

      <div className={CN.cardInfo}>
        <div className={CN.title}>{title}</div>

        {isSalonInGB && (
          <ExternalLink link={link} variant="card">
            {t('slickPay.onlinePayments.learnMoreButton')}
          </ExternalLink>
        )}
      </div>
    </div>
  );
};

export default CardItem;
